/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "ProcessingMode": {
            "values": {
              "UNKNOWN_PROCESSING_MODE": 0,
              "ONLINE": 1,
              "STORE_AND_FORWARD": 2
            }
          },
          "Flow": {
            "values": {
              "UNKNOWN_FLOW": 0,
              "NONE": 1,
              "OPEN_TICKETS_SYNC": 2,
              "PAYMENT_CREATION": 3,
              "PAYMENT_HISTORY": 4,
              "REOPEN": 5
            }
          },
          "AppVersionRange": {
            "fields": {
              "since": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "until": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "AppVersionRanges": {
            "fields": {
              "value": {
                "type": ".squareup.client.AppVersionRange",
                "id": 1,
                "rule": "repeated"
              }
            }
          },
          "FieldAccessModes": {
            "fields": {
              "read": {
                "type": ".squareup.client.Flow",
                "id": 1,
                "rule": "repeated"
              },
              "write": {
                "type": ".squareup.client.Flow",
                "id": 2,
                "rule": "repeated"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.client?.nested?.ProcessingMode && !$root.nested?.squareup?.nested?.client?.nested?.Flow && !$root.nested?.squareup?.nested?.client?.nested?.AppVersionRange && !$root.nested?.squareup?.nested?.client?.nested?.AppVersionRanges && !$root.nested?.squareup?.nested?.client?.nested?.FieldAccessModes) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ProcessingMode @ squareup/client/options.proto at 12:1
 */
export const ProcessingMode = $root.lookupEnum('squareup.client.ProcessingMode').values;
/**
 * SOURCE Flow @ squareup/client/options.proto at 21:1
 */
export const Flow = $root.lookupEnum('squareup.client.Flow').values;
/**
 * Message to annotate a proto file, message, field, enum, enum value, service or RPC
 * to document the client App version for which it was introduced and the last version
 * after which its use is stopped.
 *
 * SOURCE AppVersionRange @ squareup/client/options.proto at 36:1
 */
export const AppVersionRange = $root.lookupType('squareup.client.AppVersionRange');
fixType(AppVersionRange);
Builder.createAndAttachToType(AppVersionRange);
/**
 * SOURCE AppVersionRanges @ squareup/client/options.proto at 69:1
 */
export const AppVersionRanges = $root.lookupType('squareup.client.AppVersionRanges');
fixType(AppVersionRanges);
Builder.createAndAttachToType(AppVersionRanges);
/**
 * Message to annotate which flows can read and/or write a field.
 *
 * SOURCE FieldAccessModes @ squareup/client/options.proto at 77:1
 */
export const FieldAccessModes = $root.lookupType('squareup.client.FieldAccessModes');
fixType(FieldAccessModes);
Builder.createAndAttachToType(FieldAccessModes);